import { green, orange, red, blue, purple, grey } from "@mui/material/colors";

export const colors: GroupColorPalette[] = ["GREEN", "ORANGE", "PURPLE", "RED"];

export const USER_COLORS: Dic<Dic<string>> = {
  green: {
    green1: green[300],
    green2: green[400],
    green3: green[500],
    green4: green[600],
    green5: green[700],
    green6: green[800],
    green7: green[900],
  },
  blue: {
    blue1: blue[300],
    blue2: blue[400],
    blue3: blue[500],
    blue4: blue[600],
    blue5: blue[700],
    blue6: blue[800],
    blue7: blue[900],
  },
  orange: {
    orange1: orange[300],
    orange2: orange[400],
    orange3: orange[500],
    orange4: orange[600],
    orange5: orange[700],
    orange6: orange[800],
    orange7: orange[900],
  },
  purple: {
    purple1: purple[300],
    purple2: purple[400],
    purple3: purple[500],
    purple4: purple[600],
    purple5: purple[700],
    purple6: purple[800],
    purple7: purple[900],
  },
  red: {
    red1: red[300],
    red2: red[400],
    red3: red[500],
    red4: red[600],
    red5: red[700],
    red6: red[800],
    red7: red[900],
  },
  grey: {
    grey1: grey[300],
    grey2: grey[400],
    grey3: grey[500],
    grey4: grey[600],
    grey5: grey[700],
    grey6: grey[800],
    grey7: grey[900],
  },
};
